<div class="main-container">
    <div class="header">
        Company Settings
    </div>
    <div>
        <mat-tab-group mat-align-tabs="start" (selectedTabChange)="onTabChanged($event);">
            <mat-tab label="Company Setup">
                <app-company-list #createTemplates  ></app-company-list>
            </mat-tab>
            <mat-tab label="Template Setup">
                <app-template-setup [allCompanies]='allCompanies'></app-template-setup>
            </mat-tab>
            <mat-tab label="Themes">
                <div class="theme-configuration-container">
                    <!-- Company Selection Header -->
                    <div class="theme-header">
                        <h2>Theme Configuration</h2>
                        <p>Customize your company's visual identity and branding</p>
                        <mat-form-field class="company-selector" appearance="outline">
                            <mat-label>Select Company</mat-label>
                            <mat-select [(ngModel)]="selectedCompany.id">
                                <mat-option *ngFor="let company of allCompanies" [value]="company.id" (click)="onSelectCompany(company)">
                                    {{company.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="theme-content">
                        <!-- Left Panel - Configuration -->
                        <div class="theme-config-panel">
                            <mat-card class="config-card color-config-card">
                                <mat-card-header>
                                    <mat-card-title>
                                        <mat-icon>palette</mat-icon>
                                        Brand Colors
                                    </mat-card-title>
                                    <mat-card-subtitle>Define your brand's visual identity</mat-card-subtitle>
                                </mat-card-header>
                                <mat-card-content>
                                    <div class="color-picker-container">
                                        <!-- Primary Color -->
                                        <div class="color-picker-field">
                                            <div class="color-field-header">
                                                <label class="color-label">Primary Color</label>
                                                <span class="color-hex">{{customerData.themecolour || '#0080F5'}}</span>
                                            </div>
                                            <div class="color-input-group">
                                                <input type="color" 
                                                       [(ngModel)]="customerData.themecolour" 
                                                       class="color-picker-input-large"
                                                       (change)="onColorChange('primary', $event)">
                                                <div class="color-presets">
                                                    <div class="preset-color" 
                                                         *ngFor="let color of primaryColorPresets" 
                                                         [style.background-color]="color"
                                                         (click)="selectPresetColor('primary', color)"
                                                         [class.active]="customerData.themecolour === color"
                                                         [title]="color">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Secondary Color -->
                                        <div class="color-picker-field">
                                            <div class="color-field-header">
                                                <label class="color-label">Secondary Color</label>
                                                <span class="color-hex">{{customerData.secondarycolour || '#6C757D'}}</span>
                                            </div>
                                            <div class="color-input-group">
                                                <input type="color" 
                                                       [(ngModel)]="customerData.secondarycolour" 
                                                       class="color-picker-input-large"
                                                       (change)="onColorChange('secondary', $event)">
                                                <div class="color-presets">
                                                    <div class="preset-color" 
                                                         *ngFor="let color of secondaryColorPresets" 
                                                         [style.background-color]="color"
                                                         (click)="selectPresetColor('secondary', color)"
                                                         [class.active]="customerData.secondarycolour === color"
                                                         [title]="color">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </mat-card-content>
                            </mat-card>

                            <mat-card class="config-card">
                                <mat-card-header>
                                    <mat-card-title>Brand Assets</mat-card-title>
                                    <mat-card-subtitle>Upload your company images</mat-card-subtitle>
                                </mat-card-header>
                                <mat-card-content>
                                    <!-- Company Logo -->
                                    <div class="upload-field">
                                        <input #companyImageInput hidden="true" type="file" name="logo" onclick="this.value=null" (change)="uploadImage($event, 'logo')" accept="image/*"/>
                                        <div class="upload-item" (click)="companyImageInput.click()">
                                            <mat-icon class="upload-icon">business</mat-icon>
                                            <div class="upload-info">
                                                <span class="upload-label">Company Logo</span>
                                                <span class="upload-status">{{selectedFiles.logo?.name || 'Click to upload'}}</span>
                                            </div>
                                            <mat-icon class="upload-action">cloud_upload</mat-icon>
                                        </div>
                                    </div>

                                    <!-- Dashboard Image -->
                                    <div class="upload-field">
                                        <input #dashboardImageInput hidden="true" type="file" name="dashboard" onclick="this.value=null" (change)="uploadImage($event, 'dashboard')" accept="image/*"/>
                                        <div class="upload-item" (click)="dashboardImageInput.click()">
                                            <mat-icon class="upload-icon">dashboard</mat-icon>
                                            <div class="upload-info">
                                                <span class="upload-label">Dashboard Image</span>
                                                <span class="upload-status">{{selectedFiles.dashboard?.name || 'Click to upload'}}</span>
                                            </div>
                                            <mat-icon class="upload-action">cloud_upload</mat-icon>
                                        </div>
                                    </div>

                                    <!-- PDF Image -->
                                    <div class="upload-field">
                                        <input #pdfImageInput hidden="true" type="file" name="pdf" onclick="this.value=null" (change)="uploadImage($event, 'pdf')" accept="image/*"/>
                                        <div class="upload-item" (click)="pdfImageInput.click()">
                                            <mat-icon class="upload-icon">picture_as_pdf</mat-icon>
                                            <div class="upload-info">
                                                <span class="upload-label">PDF Header Image</span>
                                                <span class="upload-status">{{selectedFiles.pdf?.name || 'Click to upload'}}</span>
                                            </div>
                                            <mat-icon class="upload-action">cloud_upload</mat-icon>
                                        </div>
                                    </div>
                                </mat-card-content>
                            </mat-card>

                            <!-- Action Buttons -->
                            <mat-card class="action-card">
                                <mat-card-content>
                                    <div class="theme-actions">
                                        <button mat-stroked-button 
                                                class="reset-btn" 
                                                (click)="onResetTheme()" 
                                                [disabled]="imageLoading">
                                            <mat-icon>refresh</mat-icon>
                                            Reset All Changes
                                        </button>
                                        <button mat-flat-button 
                                                color="primary" 
                                                class="save-btn"
                                                (click)="onSubmitTheme()" 
                                                [disabled]="imageLoading || !hasChanges()">
                                            <mat-icon *ngIf="!imageLoading">save</mat-icon>
                                            <mat-spinner *ngIf="imageLoading" diameter="20"></mat-spinner>
                                            {{imageLoading ? 'Saving Changes...' : 'Save Theme Configuration'}}
                                        </button>
                                    </div>
                                    <div class="action-info" *ngIf="!hasChanges() && !imageLoading">
                                        <mat-icon>info</mat-icon>
                                        <span>Make changes to colors or upload images to enable saving</span>
                                    </div>
                                </mat-card-content>
                            </mat-card>
                        </div>

                        <!-- Right Panel - Preview -->
                        <div class="theme-preview-panel">
                            <mat-card class="preview-card">
                                <mat-card-header>
                                    <mat-card-title>Live Preview</mat-card-title>
                                    <mat-card-subtitle>See how your theme will look</mat-card-subtitle>
                                </mat-card-header>
                                <mat-card-content>
                                    <div class="preview-container">
                                        <!-- Brand Assets Preview -->
                                        <div class="preview-section">
                                            <h4>Brand Assets</h4>
                                            <div class="brand-assets-preview">
                                                <!-- Company Logo -->
                                                <div class="asset-preview">
                                                    <div class="asset-label">Company Logo</div>
                                                    <div class="asset-display">
                                                        <img *ngIf="getPreviewImage('logo')" [src]="getPreviewImage('logo')" alt="Company Logo" />
                                                        <div *ngIf="!getPreviewImage('logo')" class="asset-placeholder">
                                                            <mat-icon>business</mat-icon>
                                                            <span>No logo uploaded</span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <!-- Dashboard Image -->
                                                <div class="asset-preview">
                                                    <div class="asset-label">Dashboard Image</div>
                                                    <div class="asset-display">
                                                        <img *ngIf="getPreviewImage('dashboard')" [src]="getPreviewImage('dashboard')" alt="Dashboard Image" />
                                                        <div *ngIf="!getPreviewImage('dashboard')" class="asset-placeholder">
                                                            <mat-icon>dashboard</mat-icon>
                                                            <span>No dashboard image</span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <!-- PDF Image -->
                                                <div class="asset-preview">
                                                    <div class="asset-label">PDF Header Image</div>
                                                    <div class="asset-display">
                                                        <img *ngIf="getPreviewImage('pdf')" [src]="getPreviewImage('pdf')" alt="PDF Header Image" />
                                                        <div *ngIf="!getPreviewImage('pdf')" class="asset-placeholder">
                                                            <mat-icon>picture_as_pdf</mat-icon>
                                                            <span>No PDF image</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Color and UI Preview -->
                                        <div class="preview-section">
                                            <h4>Theme Preview</h4>
                                            
                                            <!-- Color Swatches -->
                                            <div class="color-swatches">
                                                <div class="swatch">
                                                    <div class="swatch-color" [style.background-color]="customerData.themecolour || '#0080F5'"></div>
                                                    <span>Primary</span>
                                                </div>
                                                <div class="swatch">
                                                    <div class="swatch-color" [style.background-color]="customerData.secondarycolour || '#6C757D'"></div>
                                                    <span>Secondary</span>
                                                </div>
                                            </div>

                                            <!-- Sample UI Preview -->
                                            <div class="ui-preview">
                                                <div class="sample-header" [style.background-color]="customerData.themecolour || '#0080F5'">
                                                    <img *ngIf="getPreviewImage('logo')" [src]="getPreviewImage('logo')" alt="Logo" class="header-logo" />
                                                    <span>{{selectedCompany.name || 'Company Name'}}</span>
                                                </div>
                                                <div class="sample-content">
                                                    <div class="sample-button" [style.background-color]="customerData.themecolour || '#0080F5'">
                                                        Primary Button
                                                    </div>
                                                    <div class="sample-button secondary" [style.background-color]="customerData.secondarycolour || '#6C757D'">
                                                        Secondary Button
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </mat-card-content>
                            </mat-card>
                        </div>
                    </div>
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>
</div>